<template>
    <div class="onboarding-step onboarding-step-base">
        <onboarding-counter
            :step="step"
            :total-steps="totalSteps"
        />
        <p class="question">
            {{ step }}. {{ control.data.question }}
        </p>
        <template v-if="control.data.type !== 'text'">
            <radio-control
                v-model="answer"
                :layout="control.data.type"
                :options="control.data.options"
                :label="control.data.label"
            />
        </template>
        <template v-else>
            <text-control
                v-model="answer"
                :label="control.data.label"
            />
        </template>

        <onboarding-controls
            :show-previous-btn="1 !== step"
        />
    </div>
</template>

<script>
import OnboardingControls from './OnboardingControls.vue';
import OnboardingCounter from './OnboardingCounter.vue';
import RadioControl from './Controls/RadioControl.vue';
import TextControl from './Controls/TextControl.vue';
import { mapState } from 'vuex';

export default {
    components: {
        OnboardingCounter,
        RadioControl,
        TextControl,
        OnboardingControls,
    },

    props: {
        step: {
            type: Number,
            default: 0,
        },
        totalSteps: {
            type: Number,
            default: 0,
        },
        control: {
            type: Object,
            default: () => {},
        },
    },

    data: () => ({
        answer: null,
    }),

    computed: mapState({
        userMeta: state => state.user.meta_data,
    }),

    /**
     * Created hook
     *
     * @returns {void}
     */
    created() {
        if (this.userMeta[this.control.name]) {
            this.answer = this.userMeta[this.control.name];
        }
    },
};
</script>
